import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { Model } from '../two-factor';
import type RouterService from '@ember/routing/router-service';

export default class TwoFactorRoute extends Route {
  @service router!: RouterService;

  redirect(model: Model) {
    if (model.smsTwoFactor === undefined) {
      this.router.transitionTo('signup.two-factor.enroll');
    }
  }
}
